import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";

// Ensure fonts and icons are bundled
import "@mdi/font/css/materialdesignicons.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";

const app = createApp(App);
app.use(vuetify);
app.use(store);
app.mount("#app");
